// src/mobile/MobileFooter.js
// Mobile-optimized footer with sitemap and contact info

import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import './styles/mobile-footer.css';

const MobileFooter = () => {
  return (
    <footer className="mobile-footer">
      {/* Brand Section */}
      <div className="mobile-footer__brand">
        <h3 className="mobile-footer__logo">Rosalytics</h3>
        <p className="mobile-footer__tagline">
          Operational Intelligence for the Modern Enterprise
        </p>
      </div>

      {/* Links Grid */}
      <div className="mobile-footer__grid">
        {/* Capabilities */}
        <div className="mobile-footer__column">
          <h4 className="mobile-footer__heading">Capabilities</h4>
          <ul className="mobile-footer__list">
            <li>GenAI Solutions</li>
            <li>Manufacturing Analytics</li>
            <li>Custom Applications</li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="mobile-footer__column">
          <h4 className="mobile-footer__heading">Quick Links</h4>
          <ul className="mobile-footer__list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/resources">Resources</Link></li>
            <li><a href="/#team">Team</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
      </div>

      {/* Contact Info */}
      <div className="mobile-footer__contact">
        <div className="mobile-footer__contact-item">
          <MapPin size={16} />
          <span>Milwaukee, WI, United States</span>
        </div>
        <a href="mailto:info@rosalytics.com" className="mobile-footer__email">
          <Mail size={16} />
          <span>info@rosalytics.com</span>
        </a>
      </div>

      {/* Copyright */}
      <div className="mobile-footer__copyright">
        <p>&copy; 2025 Rosalytics. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default MobileFooter;
